export default {
    wss: 'wss://reelshortpro.com/ws',
    host: 'https://reelshortpro.com',
    web_host: 'https://wap.reelshortpro.com',
}